import React from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'

import I18n from 'lib/i18n'
import railsContext from 'lib/selectors/rails-context'

import courseLogic from '~/scenes/course/show/logic'

const Translate = () => {
  const { translateProfile } = useActions(courseLogic)
  const { course, translating } = useValues(courseLogic)
  const { i18nLocale } = useSelector(railsContext)

  const { profileLocale, profileManualLocales, availableLocales } = course

  const handleTranslate = () => {
    const { profileLocale, defaultProfileLocale } = course
    translateProfile(profileLocale === i18nLocale ? defaultProfileLocale : i18nLocale)
  }

  if (availableLocales && availableLocales.length < 2) {
    return null
  }

  if (availableLocales.indexOf(i18nLocale) < 0) {
    return null
  }

  if (profileManualLocales.includes(i18nLocale)) {
    return null
  }

  return (
    <div>
      <span
        className='translate translatebutton'
        onClick={handleTranslate}
        style={{ cursor: translating ? 'wait' : 'pointer' }}
      >
        {i18nLocale === profileLocale
          ? I18n.t('jstemplates.searchresult.translated')
          : I18n.t('jstemplates.searchresult.translate')}
      </span>
    </div>
  )
}

export default Translate
